"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
DashboardService.$inject = ['api'];
function DashboardService(api) {
}
exports.DashboardService = DashboardService;



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/dashboard/services/dashboard.js
// module id = 347
// module chunks = 0